module.exports = __webpack_public_path__ + "img/banner2_1_en.22f8f41d.png";